import wrapComponent from "../../core/wrapComponent";
import DeckSwiper from "./default";
export default wrapComponent( // @ts-ignore
DeckSwiper, {});